import { render, staticRenderFns } from "./BaseSetup.vue?vue&type=template&id=8430d074&scoped=true&"
import script from "./BaseSetup.vue?vue&type=script&lang=js&"
export * from "./BaseSetup.vue?vue&type=script&lang=js&"
import style0 from "./BaseSetup.vue?vue&type=style&index=0&id=8430d074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8430d074",
  null
  
)

export default component.exports